import { render, staticRenderFns } from "./AreaPopup.vue?vue&type=template&id=306b450a&scoped=true&"
import script from "./AreaPopup.vue?vue&type=script&lang=ts&"
export * from "./AreaPopup.vue?vue&type=script&lang=ts&"
import style0 from "./AreaPopup.vue?vue&type=style&index=0&id=306b450a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306b450a",
  null
  
)

export default component.exports